import Vue from "vue";
// -- Global mixins for communications
Vue.mixin({
    methods: {
        iconType(comm) {
            const icons = {
                1: "phone", // phone
                2: "user_comment", // in person
                3: "printer", // fax
                4: "email", // email
                5: "email_edit", // mail
                6: "comment", // sms
                7: "webcam" // telehealth
            };
            if (comm.master_communication_type) {
                return `famfamfam-silk ${
                    icons[comm.master_communication_type.id] || "comments"
                }`;
            } else {
                return `famfamfam-silk ${icons[6]}`;
            }
        },
        commTypeTitle(comm) {
            if (comm.master_communication_type) {
                return comm.master_communication_type.value;
            }

            return "";
        },
        formatContent(html) {
            let hasAttachment = html.includes(`<div id="bcc_attachment">`);

            if (hasAttachment) {
                let index = html.indexOf(`<div id="bcc_attachment">`);
                let str = html.substr(index);
                return html.replace(str, "");
            }

            return html;
        },
        extractBccAttachment(html) {
            let hasAttachment = html.includes(`<div id="bcc_attachment">`);

            if (hasAttachment) {
                let index = html.indexOf(`<div id="bcc_attachment">`);
                let str = html.substr(index);

                let arr = $(str).find("a").toArray();
                let result = [];

                for (const element of arr) {
                    result.push(element.outerHTML);
                }

                return result.join("<br/>");
            }
        }
    }
});
